import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { FaHamburger } from "react-icons/fa";
import { MdClose } from "react-icons/md";
import { Link } from "react-router";
import Button from "../../parts/Button";
import HeaderOne from "../../parts/HeaderOne";
import Menu from "../../parts/Menu";
import { api } from "../../../../api";
import LinkButton from "../../parts/LinkButton";

const MenuButtonStyle = styled(Button)`
  position: fixed;
  top: 25px;
  right: 30px;
  flex-shrink: 0;
  z-index: 2;

  @media (max-width: 768px) {
    top: 10px;
    right: 10px;
  }
`;

const HeaderStyle = styled.div`
  display: flex;
  align-items: center;
  background: #f2f0e9;
  justify-content: space-between;
  padding: 20px 30px;

  @media (max-width: 768px) {
    padding: 10px 15px;
  }
`;

const SiteNameLink = styled(Link)`
  color: #383432;
  text-decoration: none;

  :hover {
    color: #737373;
  }
`;

const FieldsStyle = styled.div`
  display: flex;
  column-gap: 10px;
  justify-content: space-between;
`;

const AdministratorHeader: React.FC = () => {
  const [login, setLogin] = useState<boolean>(null);
  const [openMenu, setOpenMenu] = useState<boolean>(null);

  useEffect(() => {
    api
      .getAdministratorSession()
      .then((response) => {
        setLogin(!!response.data);
      })
      .catch(() => {
        setLogin(false);
      });
  }, []);

  const onClickMenu = () => {
    setOpenMenu(!openMenu);
  };

  const LoginStateDisplay = () => {
    return (
      <>
        <MenuButtonStyle onClick={onClickMenu}>
          {openMenu ? <MdClose /> : <FaHamburger />}
        </MenuButtonStyle>
        <Menu
          items={[
            { name: "トップ", link: "/" },
            { name: "ダッシュボード", link: "/administrator/dashboard" },
            { name: "店舗申請一覧", link: "/administrator/draft-shops" },
            { name: "店舗作成", link: "/administrator/create-shop" },
            { name: "ユーザー一覧", link: "/administrator/users" },
            { name: "オーナー一覧", link: "/administrator/owners" },
          ]}
          open={openMenu}
          setOpen={setOpenMenu}
        />
      </>
    );
  };

  const LogoutStateDisplay = () => {
    return (
      <>
        <LinkButton href="/administrator/login">ログイン</LinkButton>
      </>
    );
  };

  const HeaderMenu = () => {
    if (login !== null) {
      return login ? <LoginStateDisplay /> : <LogoutStateDisplay />;
    }
    return;
  };

  return (
    <HeaderStyle>
      <HeaderOne>
        <SiteNameLink to="/administrator/dashboard">
          Cafect管理画面
        </SiteNameLink>
      </HeaderOne>
      <FieldsStyle>
        <HeaderMenu />
      </FieldsStyle>
    </HeaderStyle>
  );
};

export default AdministratorHeader;
